const indexItems = [
  { name: '明星恋情', count: '2,341', icon: 'ri-heart-line' },
  { name: '综艺内幕', count: '1,892', icon: 'ri-tv-line' },
  { name: '直播翻车', count: '1,756', icon: 'ri-live-line' },
  { name: '影视八卦', count: '1,623', icon: 'ri-film-line' },
  { name: '网红黑料', count: '1,548', icon: 'ri-user-smile-line' },
  { name: '豪门恩怨', count: '1,423', icon: 'ri-vip-crown-line' },
  { name: '音乐圈瓜', count: '1,387', icon: 'ri-music-line' },
  { name: '时尚花边', count: '1,296', icon: 'ri-shirt-line' },
  { name: '体育娱乐', count: '1,184', icon: 'ri-basketball-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            主题索引
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">按分类浏览51吃瓜网今日吃瓜资源，快速找到你感兴趣的内容领域</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.name}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-3 bg-background-100 rounded-2xl px-5 py-4 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center shrink-0 group-hover:bg-secondary-200 transition-colors">
                <i className={`${item.icon} text-secondary-600 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm font-medium text-foreground-800 block">{item.name}</span>
                <span className="text-xs text-foreground-500">{item.count} 条内容</span>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}